export default Object.freeze({
  // SETTLEMENT_PARTNER_
  TITLE: '매출 내역 조회',
  TOP_MSG1: '조회일자 기준으로 전일자 데이터까지 집계되며, 옵션 매출 금액은 실제 지급 받을 금액과 다를 수 있습니다.',
  TOP_MSG2: '실제 지급 금액은',
  TOP_MSG3: '파트너관리',
  TOP_MSG4: '정산 현황 조회',
  TOP_MSG5: '에서 확인 가능합니다.',
  TOP_MSG6: '공제금액 = 각 금액조정 파트너부담+쇼핑몰 배송비-환불보류 금액조정',
  TOP_MSG7: '판매수수료는 주문 시점 상품 수수료기준으로 산출됩니다.',
  TOP_MSG8: '판매수수료 계산 방식 : 공급가 직접 입력인 경우 (판매액-공급가), 상품수수료율 방식인 경우 (판매액*수수료율), 사입상품인 경우 (판매액-매입가)',
  TOP_MSG9: '네이버페이의 주문형 정책에 따라 클레임에 대한 조정금액(반품 배송비, 기타 비용)이 발생하는 경우 <a href="https://admin.pay.naver.com/" target="_blank">네이버페이센터</a>에서 확인되는 금액과 오차가 발생할 수 있습니다.',
  MONTH_SELECT: '월별',
  PERIOD_SELECT: '일별',
  TOTAL_SALES: '매출 합계',
  DAILY_SALES: '일별 매출 상세',

  HEADER_SEARCH_YMD: '조회일자',
  HEADER_ORDER_CNT: '판매수량',
  HEADER_REFUND_CNT: '환불수량',
  HEADER_SALES_AMT: '판매액(A)',
  HEADER_COMMISSION_AMT: '판매수수료(B)',
  HEADER_DELIVERY_AMT: '배송비(C)',
  HEADER_PARTNER_DISCOUNT_AMT: '추가/상품/사은품할인파트너부담(D)',
  HEADER_DEDUCTED_AMT: '공제금액(E)',
  HEADER_SETTLEMENT_AMT: '정산예상금액(F=A-B+C-D-E)',

  DEDUCTED_AMT_TITLE: '공제금액(E)',
  DEDUCTED_AMT_1: '<b>공제금액(E)</b> 항목 출력 값은 엑셀 파일 기준으로<br /><b>상품금액조정 파트너부담(E)+배송비금액조정 파트너부담(F)+쇼핑몰배송비(G)-환불보류 금액조정(H)</b> 입니다.',

  EXCEL_NAME_TOTAL_SALES: '매출합계',
  EXCEL_NAME_DAILY_SALES: '일별매출'
});
